import React, { useEffect, useState } from 'react'
import { Button, Card, Table } from 'react-bootstrap'
import NavSearch from '../layouts/AdminLayout/NavBar/NavLeft/NavSearch';
import { useNavigate } from 'react-router-dom';
import { getServerURL } from '../helper/envConfig';
import api from '../helper/api';
import PaginationC from './pagination';
import Loader from './Loader/Loader';

const ProductDetails = (props) => {

    const [searchText, setSearchText] = useState("");
    const [loading, setLoading] = useState(true)
    const navigate = useNavigate()

    const serverURL = getServerURL()
    const [data, setData] = useState([])
    const [paginationData, setPaginationData] = useState({})
    const [page, setPage] = useState(1)

    useEffect(() => {
        if (searchText?.length) setPage(1);
    }, [searchText]);

    useEffect(() => {
        getAllProduct();
    }, [searchText, page]);

    const getAllProduct = (event) => {
        setLoading(true)
        api.getWithToken(`${serverURL}product/?page=${page}${searchText && `&_i=${searchText}`}`)
            .then(async (res) => {
                const { data, links, page, page_size, total, total_pages } = res?.data;
                setPaginationData({ links, page, page_size, total, total_pages })
                setLoading(false)
                if (res?.data?.success === true) {
                    setData(res?.data?.data);
                }
            })
            .catch((e) => {
                setLoading(false)
            });
    };

    const isActiveStatusFun = (id, status) => {
        const formData = new FormData();
        formData.append("status", status)

        setLoading(true)
        api.postWithToken(`${serverURL}create-product/active-inactive-product/${id}/`, formData)
            .then(async (res) => {
                getAllProduct()
            })
            .catch((e) => {
                setLoading(false)
            });
    };


    return (
        <>
            <Card className="user-list">
                <Card.Header>
                    <div className='d-flex justify-content-between align-items-center'>
                        <Card.Title as="h4">{props?.title || ""}</Card.Title>
                        <div className='d-flex align-items-center'>
                            <header className="navbar pcoded-header" style={{ backgroundColor: "#fff" }}> <NavSearch searchText={searchText} setSearchText={setSearchText} /></header>
                            <Button variant={"outline-primary"} className='m-0' onClick={() => { navigate("/add-product") }}>
                                {"Add"}
                            </Button>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Table responsive hover className='product-table'>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Full Name</th>
                                <th>Type</th>
                                <th>Sub Type</th>
                                <th>Category</th>
                                <th>Shape</th>
                                <th>Metal</th>
                                <th>Is Active</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Boolean(loading) ?
                                <tr>
                                    <td colSpan={6} className='text-center'>
                                        <Loader loading={loading} />
                                    </td>
                                </tr>
                                :
                                Boolean(data?.length) ? data?.map((item, index) =>
                                    <tr key={index + "productAll"}>
                                        <td>{(10 * (page - 1)) + (index + 1)}</td>
                                        <td>
                                            <h6 className="m-0">{item?.full_name || "-"} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.type || "-"} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.sub_type || "-"} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.category?.join(", ") || "-"} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.shape?.join(", ") || "-"} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.metal_product?.join(", ") || "-"} </h6>
                                        </td>
                                        <td>
                                            <div class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" onChange={(e) => isActiveStatusFun(item?.group_id, e?.target?.checked)} checked={item?.is_active} />
                                            </div>
                                        </td>

                                        <td>
                                            <div className='d-flex align-items-center gap-3'>
                                                {/* <div className='cursor-pointer' onClick={() => setViewModalShow(true)}>
                                                <i className="feather icon-eye" title='View' />
                                            </div> */}
                                                <div className='cursor-pointer' onClick={() => { navigate("/edit-product", { state: item?.group_id }); }}>
                                                    <i className="feather icon-edit" title='Edit' />
                                                </div>
                                                {/* <div className='cursor-pointer' onClick={() => { setDeleteData(item?.slug); setDeleteModalShow(true) }}>
                                                    <i className="feather icon-trash-2" title='Delete' />
                                                </div> */}
                                            </div>
                                        </td>
                                    </tr>
                                )
                                    :
                                    <tr>
                                        <td colSpan={7} className='text-center'>
                                            There are no records available at the moment.
                                        </td>
                                    </tr>
                            }

                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {Boolean(data?.length) && paginationData?.total_pages > 1 &&
                <PaginationC data={paginationData}
                    onPageChange={(newPage) => {
                        setPage(newPage);
                    }} />
            }
        </>
    )
}

export default ProductDetails